import { IntentActionTypes } from '../../model/intent/action';
import { FlowState, Flow } from '../../model/workflowEditor/flow/types';
import { fillBotFlowsActionType, saveFlowActionType } from '../../model/workflowEditor/flow/actions';
import produce from 'immer';
import { replaceOrInsert } from '../../helpers/immutableHelper';

const initialState: FlowState = {
  flows: []
};

export function flowReducer(
  state = initialState,
  action: IntentActionTypes,
): FlowState {
  switch (action.type) {
    case fillBotFlowsActionType.success:
    return produce(state, draftState => {
      draftState.flows = action.payload;
    });
    case saveFlowActionType.success:
      return {
        flows: replaceOrInsert<Flow>(state.flows, action.payload),
      };
    default:
      return state;
  }
}
